import { useMutation } from "@tanstack/react-query";

import { tableSerializationApi } from "src/api/endpoints";

export const useImportDecisionTable = () =>
  useMutation({
    mutationFn: async ({
      flowVersionId,
      nodeId,
      file,
    }: {
      flowVersionId: string;
      nodeId: string;
      file: File;
    }) => {
      return await tableSerializationApi.importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost(
        flowVersionId,
        nodeId,
        file,
      );
    },
  });

export const useExportDecisionTable = () =>
  useMutation({
    mutationFn: async ({
      flowVersionId,
      nodeId,
    }: {
      flowVersionId: string;
      nodeId: string;
    }) => {
      const response =
        await tableSerializationApi.exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet(
          flowVersionId,
          nodeId,
          { responseType: "blob" },
        );
      return response.data;
    },
  });
